import $ from 'jquery';
import * as helpers from './helpers';
import { els, constants, breakpoints } from './variables';

const quantityInputs = $('input.qty');

function maybeUpdatePrice(e) {
	const input = $(this);
	const product = input.closest('[data-bulk]');
	let bulkData = product.attr('data-bulk');
	const basePrice = parseFloat(product.attr('data-base-price'));
	const priceEls = product.find('.price');

	if (bulkData) {
		bulkData = bulkData.replace(/'/g, '"');
		bulkData = JSON.parse(bulkData);
		bulkData = $.map(bulkData, function(value, i) {
			return [value];
		});

		const value = parseInt(input.val());
		let discount = false;

		for (let i = bulkData.length - 1; i >= 0; i--) {
			const bulkQty = parseInt(bulkData[i].quantity);
			const bulkDiscount = parseInt(bulkData[i].discount);

			if (value >= bulkQty) {
				discount = 1 - bulkDiscount / 100;
				break;
			}
		}

		priceEls.each(function() {
			const priceEl = $(this);
			let newPriceEl = priceEl.find('+ .new-price');
			const currency = priceEl
				.find('.woocommerce-Price-currencySymbol')
				.text();

			if (!newPriceEl.length) {
				priceEl.after('<span class="amount new-price"></span>');
				newPriceEl = priceEl.find('+ .new-price');
			}

			if (discount) {
				const discountPrice = (basePrice * discount).toFixed(2);
				newPriceEl
					.text(currency + discountPrice)
					.delay(300)
					.addClass('active');
				priceEl.find('.woocommerce-Price-amount').addClass('old-price');
				product.addClass('has-discount');
			} else {
				newPriceEl
					.removeClass('active')
					.delay(300)
					.text('');
				priceEl
					.find('.woocommerce-Price-amount')
					.removeClass('old-price');
				product.removeClass('has-discount');
			}
		});
	}
}

quantityInputs.on('input', maybeUpdatePrice);
